import { type FC } from 'react'
import { ISO8601Duration } from '@opallabs/concepts'
import { DurationControl } from '@opallabs/satellite'
import { type DurationFieldProps, type FieldInputProps } from '../../types'
import { useSwappableField } from '../../useSwappableField'
import { TextDisplay } from '../TextDisplay'

export const FieldDuration: FC<FieldInputProps<DurationFieldProps>> = ({
  durationOptions,
  field,
  onChange,
  readOnly = false,
  setIsEditing,
}) => {
  const { setDisplayRef } = useSwappableField({ setIsEditing })

  const wrappedOnChange = (duration: ISO8601Duration.Representation | null) => {
    onChange({
      data: {
        id: field.data?.id ?? null,
        value: duration !== null ? { value: duration } : null,
      },
      fieldId: field.id,
    })
  }

  if (readOnly) {
    let humanized: string | undefined = undefined
    if (field.data?.value?.value) {
      humanized = ISO8601Duration.toLocaleString(field.data?.value?.value)
    }

    return (
      <TextDisplay
        fieldId={field.id}
        fieldLabel={field.displayName}
        readOnly={readOnly}
        ref={setDisplayRef}
        setIsEditing={setIsEditing}
        text={humanized}
      />
    )
  }

  return (
    <DurationControl
      {...durationOptions}
      duration={field.data?.value?.value ?? null}
      htmlId={`field-${field.id}`}
      omitFieldsetName={true}
      onChange={wrappedOnChange}
    />
  )
}
FieldDuration.displayName = 'Satellite: FieldDuration ← Field'
